<template>
  <perfect-scrollbar
    class="quick-search-wrapper scroll"
    style="max-height: 40vh; position: relative;"
    v-bind:options="{ suppressScrollX: true }"
  >
    <div class="quick-search-result">

      <template v-for="(item, i) in data">
        <div
          :key="i"
          class="d-flex align-items-center flex-grow-1 mb-2"
        >
          <div v-if="item.images.length > 0" class="symbol symbol-30 flex-shrink-0">
              <div class="symbol-label"
                   :style="{ backgroundImage: 'url(' + $urlBackEnd(item.images[0].thumbnail) + ')' }">
              </div>
          </div>

          <div class="d-flex flex-column ml-3 mt-2 mb-2">
            <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: item.id}}" class="font-weight-bold text-dark text-hover-primary">
              {{ item.title }}
            </router-link>
            <div
              class="font-size-sm font-weight-bold text-muted"
            >
              {{ numberWithSpaces(item.price) }} руб.
            </div>
          </div>
        </div>
      </template>
    </div>
  </perfect-scrollbar>
</template>

<script>
export default {
  name: "KTSearchResult",
  props: {
    data: Array
  },

  methods:{

    numberWithSpaces(x){
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

  },





};
</script>
